import { Config } from "./config.interface";
import { defaultConfig } from "./default-config";

/* Note: clientConfig is populated in index.html, via indexHtmlHandler.ts in backend */
declare var clientConfig: Config;

export function getConfigValue<K extends keyof Config>(key: K): Config[K] {
  if (Object.prototype.hasOwnProperty.call(clientConfig, key)) {
    return clientConfig[key];
  }

  return defaultConfig[key];
}

/** Utility function for number values */
export function getConfigValueAsInt<K extends keyof Config>(key: K): number | null {
  const value = getConfigValue(key);
  if (value === null || value === undefined) {
    return null;
  }
  if (Number.isInteger(value)) {
    return value as number;
  }
  if (typeof value !== "string") {
    throw new Error(`Config value for ${key} is not a string or integer: ${value}`);
  }
  return parseInt(value, 10);
}
